export default "__VITE_ASSET__1fe7f8ec__"